import React, { useState, useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
    Container,
    Grid,
    useTheme,
    Box,
    Radio,
    FormControlLabel,
    RadioGroup,
    FormControl,
} from "@mui/material";
import ImagePreview from "../components/FormsUI/PreviewImage/index";
import Controls from "../components/FormsUI";
import { useAuth } from "../utility/auth";
import MemberGroupController from "../controller/MemberGroup";
import CustomizedSnackbars from "../components/Alert";
import "../css/style.css";
import { tokens } from "../theme";

const INITIAL_FORM_STATE = {
    messageType: "",
    eventType: "",
    title: "",
    venue: "",
    time: "",
    details: "",
    lions: "",
    location: "",
    date: "",
    cost: "",
    link: "",
    posterImg: null,
    memberSource: "",
    selectedGroup: null,
    memberType: "",
    selectedDDmemberType: null,
};
const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])[\/-](0?[1-9]|1[0-2])[\/-]\d{4}$/;
// const URLRegEx = /^(ftp|http|https):\/\/[a-zA-Z0-9_.%\-/]+$/;
const URLRegEx = /^(ftp|http|https):\/\/[^\s/$.?#].[^\s]*$/i;

const FORM_VALIDATION = Yup.object().shape({
    messageType: Yup.string()
        .trim("No white space allowed")
        .required("Message Type is required"),
    eventType: Yup.string()
        .trim("No white space allowed")
        .required("Event Type is required"),
    title: Yup.string()
        .trim("No white space allowed")
        .required("Title is required")
        .matches(
            /^[a-zA-Z0-9\s.,!?/()_\-:&]+$/,
            "Only basic Punctuation (.,!?/()_-:&) are allowed"
        )
        .min(3, "Title must be at least 3 characters")
        .max(75, "Title cannot exceed 75 characters"),
    venue: Yup.string()
        .trim("No white space allowed")
        .required("Venue is required")
        .matches(
            /^[a-zA-Z0-9\s.,!?/()_\-:&]+$/,
            "Only basic Punctuation (.,!?/()_-:&) are allowed"
        )
        .min(3, "Venue must be at least 3 characters")
        .max(150, "Venue cannot exceed 150 characters"),
    time: Yup.string()
        .trim("No white space allowed")
        .optional()
        .matches(
            /^[a-zA-Z0-9\s.,!?/()_\-:&]+$/,
            "Only basic Punctuation (.,!?/()_-:&) are allowed"
        )
        .min(3, "Time must be at least 3 characters")
        .max(50, "Time cannot exceed 100 characters"),
    details: Yup.string()
        .trim("No white space allowed")
        .required("Details are required")
        .matches(
            /^[a-zA-Z0-9\s.,!?/()_\-:&]+$/,
            "Only basic Punctuation (.,!?/()_-:&) are allowed"
        )
        .min(3, "Details must be at least 3 characters")
        .max(500, "Details cannot exceed 500 characters"),
    lions: Yup.string()
        .trim("No white space allowed")
        .optional()
        .matches(
            /^[a-zA-Z0-9\s.,!?/()_\-:&]+$/,
            "Only basic Punctuation (.,!?/()_-:&) are allowed"
        )
        .min(1, "Lions must be at least 1 characters")
        .max(50, "Lions cannot exceed 50 characters"),
    cost: Yup.string().trim("No white space allowed")
        .trim("No white space allowed")
        .optional()
        .matches(/^\d{3,10}$/, "Cost must be 3 to 10 digits and Only numeric values are allowed"),
    link: Yup.string()
        .trim("No white space allowed")
        .matches(
            URLRegEx,
            "example: https://itmines.co.in/"
        )
        .optional(),
    location: Yup.string()
        .trim("No white space allowed")
        .optional()
        .matches(
            /^[a-zA-Z0-9\s.,!?/()_\-:&]+$/,
            "Only basic Punctuation (.,!?/()_-:&) are allowed"
        )
        .min(3, "Message By must be at least 3 characters")
        .max(100, "Message By cannot exceed 100 characters"),
    date: Yup.string()
        .trim("No white space allowed")
        .optional()
        .matches(dateRegex, "Date must be in DD/MM/YYYY or DD-MM-YYYY format"),
    posterImg: Yup.mixed().required("Image is required"),
    memberSource: Yup.string().required("Please select a Send To option."),
    selectedGroup: Yup.object()
        .nullable()
        .when("memberSource", {
            is: "fromGroup",
            then: (schema) =>
                schema.required("Please select a group").shape({
                    id: Yup.string().required("Invalid group"),
                }),
            otherwise: (schema) => schema.nullable(),
        }),
});



const PosterSendOnWhatsApp = () => {
    const fileInputRef = useRef(null);
    const memberGroupController = new MemberGroupController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    // const { userid: tenantId } = data.UserInfo;
    // download Img
    const [downloadBtn, setDownloadBtn] = useState(false)
    const [downloadImgData, setDownloadImgData] = useState({})
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [loader, setLoader] = useState(false);
    const [updatedValues,] = useState(INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [groupOptions, setGroupOptions] = useState()
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [posterImg, setPosterImg] = useState();
    const [openQRPopUp, setOpenQRPopUp] = useState(false)

    const [popupPreview, setPopUpPreview] = useState({
        posterImg: false
    });
    const previewPopUpImage = (field, value) =>
        setPopUpPreview((prev) => ({ ...prev, [field]: value }));

    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const submitValues = async (dataValues, resetForm) => {
        try {
            let formData = new FormData();
            for (let key in dataValues) {
                formData.append(key, dataValues[key]);
            }
            setLoader(true)
            await memberGroupController.createPosteAPI(token, formData)
                .then((res) => {
                    //debugger
                    if (res?.data?.message) {
                        setDownloadBtn(true)
                        setDownloadImgData(res?.data?.body)
                        showAlert("success", res?.data?.message);
                        resetForm({ values: INITIAL_FORM_STATE });

                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setPosterImg(null);
                        setPopUpPreview((prev) => ({ ...prev, posterImg: false }));
                    } else {
                        if (res?.response?.data?.status === 400) {
                            setDownloadBtn(true)
                            setDownloadImgData(res?.response?.data?.body)
                            showAlert("error", res?.response?.data?.message)
                        } else if (res?.response?.data?.status === 500) {
                            setDownloadBtn(true)
                            setDownloadImgData(res?.response?.data?.body)
                            showAlert("error", res?.response?.data?.message)
                        } else {
                            setDownloadBtn(false)
                            showAlert("error", res?.response?.data?.message)
                        }
                    }

                    // ✅ Also clear file input manually via DOM
                    // ✅ Clear preview image and close popup

                })
                .catch((err) => {
                    if (err.response) {
                        showAlert("error", err.response.data?.message || "Something went wrong on the server.");
                    } else {
                        showAlert("error", "Something went wrong.");
                    }
                });
        } catch (error) {
            showAlert("error", "Something went wrong. Please try again.");
        } finally {
            setLoader(false);
        }
    };


    const saveFile = ({ e, setFieldValue, field }) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 4) {
            showAlert("error", "Document size should not be more than 4MB");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            return;
        }

        const extFile = getFileExtension(file.name);
        if (!isValidImageExtension(extFile)) return;

        const reader = new FileReader();
        const WIDTH = 1024;
        const IMAGE_H = 682;
        reader.onload = (event) => {
            const image = new Image();
            image.onload = () => {
                const width = image.naturalWidth;
                const height = image.naturalHeight;
                const aspectRatio = width / height;

                const REQUIRED_ASPECT_RATIO = 1024 / 682;
                const TOLERANCE = 0.3;

                if (Math.abs(aspectRatio - REQUIRED_ASPECT_RATIO) > TOLERANCE) {
                    showAlert(
                        "error",
                        `Invalid aspect ratio. Required: ${WIDTH}x${IMAGE_H} (${REQUIRED_ASPECT_RATIO.toFixed(2)})`
                    );
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    return;
                }

                // If all checks pass
                setPosterImg(event.target.result);
                setFieldValue(field, file);
            };

            image.onerror = () => {
                showAlert("error", "Invalid image file.");
            };

            image.src = event.target.result;
        };

        reader.readAsDataURL(file);
    };

    const getFileExtension = (filename) => {
        return filename.split(".").pop().toLowerCase();
    };
    const isValidImageExtension = (ext) => {
        const validExtensions = ["jpg", "jpeg", "png"];
        if (!validExtensions.includes(ext)) {
            showAlert("error", "Only jpeg, png and jpg images are allowed");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            return false;
        }
        return true;
    };

    const handleClosePopup = () => setOpenQRPopUp(false);
    const handleDownload = async () => {
        // //debugger
        // Download when click on submit 
        if (downloadImgData?.data) {

            const base64URL = `data:${downloadImgData.mimeType};base64,${downloadImgData.data}`;
            const link = document.createElement("a");
            link.href = base64URL;
            link.download = downloadImgData.fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        setDownloadBtn(false);
        setDownloadImgData({})

        // // download when call api 
        // try {
        //     let id = "68bfc781164efc695c8b1cd8";
        //     const result = await memberGroupController.downloadPoster(token, id);

        //     if (result.status !== 200) {
        //         throw new Error(result.message || "Failed to download");
        //     }
        //     const base64URL = `data:${result.data.body.mimeType};base64,${result.data.body.data}`;

        //     const link = document.createElement("a");
        //     link.href = base64URL;
        //     link.download = result.data.body.fileName;
        //     document.body.appendChild(link);
        //     link.click();
        //     link.remove();
        // } catch (error) {
        //     console.error("Download failed:", error);
        // }
    };
    return (
        <Box
            sx={{
                "& .formBg": {
                    border: `1px solid ${colors.grey[900]}`,
                    background: `${colors.primary[400]}`,
                },
                "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                "& .MuiGrid-root.Mui-heading h2": {
                    color: `${colors.primary[200]} !important`,
                },
            }}
        >
            <Grid container>
                <Grid className="breadcrumb-section">
                    <Grid className="breadcrumb-container">
                        <Grid className="Mui-li">
                            <nav className="Mui-nav" aria-label="breadcrumb">
                                <ol className="">
                                    <li className="MuiBreadcrumbs-li">
                                        <h6 className="breadsub">Home</h6>
                                    </li>
                                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                        /
                                    </li>
                                    <li className="MuiBreadcrumbs-li">
                                        <h6>Poster Send On WhatsApp</h6>
                                    </li>
                                </ol>
                            </nav>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={12} className="adduser au1 pt-2">
                    <Container maxWidth="md" className="formClwidth">
                        <Controls.Popup
                            title="Scan for WhatsApp"
                            minHeight={100}
                            openPopup={openQRPopUp}
                            setOpenPopup={handleClosePopup}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 20,
                                    background: "#fff",
                                    border: "1px solid #ccc",
                                    minHeight: 400,
                                }}
                            >
                            </div>
                        </Controls.Popup>
                    </Container>
                </Grid>
                <Grid item xs={12} className="formBg">
                    <Container maxWidth="md" className="formClwidth">
                        <div>
                            <Formik
                                enableReinitialize
                                initialValues={{ ...(updatedValues || INITIAL_FORM_STATE) }}
                                validationSchema={FORM_VALIDATION}
                                onSubmit={(values, { resetForm }) => submitValues(values, resetForm)}
                            >
                                {({ values, errors, touched, handleChange, setFieldValue, setFieldTouched }) => (
                                    <Form>
                                        <Grid container spacing={2}>

                                            <Grid item xs={12} md={6}>
                                                <Grid className="tabdata">
                                                    <h4 className="tabhead">Message type</h4>
                                                    <FormControl component="fieldset">
                                                        <RadioGroup
                                                            name="messageType"
                                                            value={values.messageType}
                                                            onChange={handleChange}
                                                        >
                                                            <FormControlLabel
                                                                value="Pre-Event"
                                                                control={<Radio />}
                                                                label="Pre-event"
                                                            />
                                                            <FormControlLabel
                                                                value="Post-Event"
                                                                control={<Radio />}
                                                                label="Post-event"
                                                            />
                                                        </RadioGroup>
                                                        {touched.messageType && errors.messageType && (
                                                            <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.messageType}</div>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Grid className="tabdata">
                                                    <h4 className="tabhead">Event type</h4>
                                                    <FormControl component="fieldset">
                                                        <RadioGroup
                                                            name="eventType"
                                                            value={values.eventType}
                                                            onChange={(event) => {
                                                                setFieldValue("eventType", event.target.value);
                                                                setFieldTouched("messageType", true, true);
                                                            }}
                                                        >
                                                            <FormControlLabel
                                                                value="Admin"
                                                                control={<Radio />}
                                                                label="Admin"
                                                            />
                                                            <FormControlLabel
                                                                value="Activity"
                                                                control={<Radio />}
                                                                label="Activity"
                                                            />
                                                        </RadioGroup>
                                                        {touched.eventType && errors.eventType && (
                                                            <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.eventType}</div>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="title"
                                                    label={
                                                        <span>
                                                            Title <span className="asterisk">*</span>
                                                        </span>
                                                    }
                                                    type="string"
                                                    inputProps={{ maxLength: 75 }}
                                                    placeholder="Title"
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="venue"
                                                    label={
                                                        <span>
                                                            Venue <span className="asterisk">*</span>
                                                        </span>
                                                    }
                                                    type="string"
                                                    inputProps={{ maxLength: 150 }}
                                                    placeholder="Venue"
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="time"
                                                    label={
                                                        <span>
                                                            Time
                                                        </span>
                                                    }
                                                    type="string"
                                                    inputProps={{ maxLength: 40 }}
                                                    placeholder="Time"
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="details"
                                                    label={
                                                        <span>
                                                            Details <span className="asterisk">*</span>
                                                        </span>
                                                    }
                                                    type="string"
                                                    inputProps={{ maxLength: 500 }}
                                                    placeholder="Details"
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="lions"
                                                    label={
                                                        <span>
                                                            Attended By
                                                        </span>
                                                    }
                                                    type="string"
                                                    inputProps={{ maxLength: 50 }}
                                                    placeholder="No. of Attendees"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="location"
                                                    label={
                                                        <span>
                                                            Message By
                                                        </span>
                                                    }
                                                    type="string"
                                                    inputProps={{ maxLength: 75 }}
                                                    placeholder="Message by"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="date"
                                                    label={
                                                        <span>
                                                            Date
                                                        </span>
                                                    }
                                                    type="string"
                                                    inputProps={{ maxLength: 10 }}
                                                    placeholder="Date"
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="cost"
                                                    label={
                                                        <span>
                                                            Cost
                                                        </span>
                                                    }
                                                    type="text"
                                                    inputProps={{ maxLength: 10 }}
                                                    placeholder="Cost"
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controls.Textfield
                                                    name="link"
                                                    label={
                                                        <span>
                                                            Link
                                                        </span>
                                                    }
                                                    type="string"
                                                    // inputProps={{ maxLength: 75 }}
                                                    placeholder="Link"
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <h4 className="tabhead">Send to</h4>
                                                <FormControl component="fieldset">
                                                    <RadioGroup
                                                        name="memberSource"
                                                        value={values.memberSource}
                                                        onChange={(event) => {
                                                            const value = event.target.value;
                                                            setFieldValue("memberSource", value);

                                                            if (value === "fromGroup") {
                                                                setFieldValue("selectedGroup", null);
                                                                memberGroupController
                                                                    .getMemberGroupList(token, userId)
                                                                    .then((resultObj) => {
                                                                        setLoader(() => false);
                                                                        if (resultObj.status === 200) {
                                                                            const userData = resultObj?.data?.data?.map((item) => {
                                                                                const { _id: id, groupName: title, _id: value } = item;
                                                                                return { id, title, value };
                                                                            });
                                                                            setGroupOptions(userData)
                                                                        }
                                                                    })
                                                            } else {
                                                                setFieldValue("selectedGroup", null);
                                                            }
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            value="selectMember"
                                                            control={<Radio />}
                                                            label="Select Member"
                                                        />
                                                        <FormControlLabel
                                                            value="fromGroup"
                                                            control={<Radio />}
                                                            label="From Group"
                                                        />
                                                    </RadioGroup>
                                                    {touched.memberSource && errors.memberSource && (
                                                        <div style={{ color: "red", fontSize: "0.8rem" }}>{errors.memberSource}</div>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            {/* Show Dropdown when 'From Group' is selected */}
                                            <Grid item xs={12} md={6}>
                                                <h3 className="upload">
                                                    Image <span className="asterisk">*</span>
                                                </h3>
                                                <input
                                                    type="file"
                                                    name="posterImg"
                                                    ref={fileInputRef}
                                                    onChange={(e) => {
                                                        let field = "posterImg";
                                                        saveFile({ e, setFieldValue, field });
                                                    }}
                                                    className="fileupload"
                                                    style={{ width: "70%" }}

                                                />
                                                <Grid className="col-lg-2" style={{ float: "right", marginRight: "15px" }}>

                                                    {posterImg && (
                                                        <img
                                                            src={posterImg}
                                                            width="55"
                                                            style={{ cursor: "pointer" }}
                                                            height="55"
                                                            onClick={() =>
                                                                setPopUpPreview((prev) => ({
                                                                    ...prev,
                                                                    posterImg: true,
                                                                }))
                                                            }
                                                            alt="Logo"
                                                            className="imgview"
                                                        />
                                                    )}
                                                </Grid>
                                                <ImagePreview
                                                    image={posterImg}
                                                    popup={popupPreview?.posterImg}
                                                    field={"posterImg"}
                                                    handlePopup={previewPopUpImage}
                                                />
                                                <ErrorMessage name="posterImg">
                                                    {(msg) => (
                                                        <div style={{ color: "#d32f2f" }}>{msg}</div>
                                                    )}
                                                </ErrorMessage>

                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                {values.memberSource === "fromGroup" && (
                                                    <Controls.AutoComplete
                                                        name="selectedGroup"
                                                        value={values.selectedGroup || null}
                                                        label={
                                                            <span>
                                                                Select Group <span className="asterisk">*</span>
                                                            </span>
                                                        }
                                                        type="string"
                                                        options={groupOptions}
                                                        getOptionLabel={(option) => option?.title || ""}
                                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                        onChange={(event, value) => {
                                                            if (value) {
                                                                // console.log('value :', value);
                                                                setFieldValue("selectedGroup", value);
                                                                setFieldValue("memberType", value?.value);
                                                                // setFieldValue("selectedDDmemberType", value);
                                                            } else {
                                                                setFieldValue("selectedGroup", null);
                                                                setFieldValue("memberType", "");
                                                                // setFieldValue("selectedDDmemberType", null);
                                                            }
                                                        }}
                                                    />

                                                )}
                                            </Grid>
                                        </Grid>

                                        {
                                            loader ? (
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <span style={{
                                                        fontSize: "20px",
                                                        fontWeight: "bold",
                                                        padding: '15px',
                                                    }}>
                                                        Message is sending...
                                                    </span>
                                                </div>
                                            ) : (
                                                <>
                                                    <Grid item xs={12} className="marginAuto">
                                                        <Grid container spacing={2} justifyContent="center">
                                                            <Grid item>
                                                                <Controls.Button>Submit</Controls.Button>
                                                            </Grid>
                                                            {downloadBtn && (
                                                                <Grid item>
                                                                    <Controls.ActionButton
                                                                        variant="contained"
                                                                        color="primary"
                                                                        fullWidth
                                                                        onClick={handleDownload}
                                                                    >
                                                                        Download
                                                                    </Controls.ActionButton>
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </>

                                            )
                                        }

                                    </Form>
                                )}
                            </Formik>
                            {alert.counter > 0 && (
                                <CustomizedSnackbars
                                    status={alert.counter}
                                    msg={alert.msg}
                                    type={alert.type}
                                />
                            )}
                        </div>
                    </Container>
                </Grid>
            </Grid>
        </Box >
    );
};

export default PosterSendOnWhatsApp;
